var NavFactory = require('./nav-factory.js');

function linkOutUrlFactory(publicationState, selected, submodel, year) {
    var linkFormatsbyPublicationState = {
        newFuture: '/' +
        [selected.make.niceName, selected.model.niceName, year, selected.submodel.niceName].join('/') +
        '/',
        used: '/' + [selected.make.niceName, selected.model.niceName, year, selected.submodel.niceName].join('/') +
        '/?ps=used',
        new: '/inventory/srp.html?radius=50&' +
        ['make=' + selected.make.name, 'model=' + submodel.modelName, 'sub=' + submodel.name].join('&')
    };
    return linkFormatsbyPublicationState[publicationState] || '#';
}

var NavLinkGenerator = function() {
    this.getLinkOutUrl = function (data) {
        var selected = NavFactory.getSelected();
        var submodel = data.submodel || {};
        var year = data.year || '';
        var publicationState = data.publicationState || '';

        return linkOutUrlFactory(publicationState, selected, submodel, year);
    };
};

module.exports = new NavLinkGenerator();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-link-generator.js
// module id = 73
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14